import { VehicleType } from '@@partner:types:app'
import { gql, useQuery } from '@apollo/client'




type Query = {
  vehicleTypes: VehicleType[]
}


export const GQL_QUERY_VEHICLE_TYPES = gql`
  query VehicleTypes {
    vehicleTypes {
      id
      name
      code
      description
    }
  }
`

export const useFetchVehicleTypes = () => {
  const { data, loading, error } = useQuery<Query>(GQL_QUERY_VEHICLE_TYPES)
  return {
    vehicleTypes: data?.vehicleTypes || [],
    data,
    loading,
    error
  }
}